(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guarantee-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gbnInit) return;
    window.__gbnInit = true;

    function update(detail) {
      if (!detail) return;
      document.querySelectorAll('[data-gbn-button]').forEach(function (btn) {
        var text = btn.querySelector('[data-gbn-text]');
        if (!text) return;

        if (detail.available === false) {
          text.textContent = btn.dataset.soldOutLabel;
          btn.setAttribute('aria-disabled', 'true');
          return;
        }

        btn.removeAttribute('aria-disabled');
        text.textContent =
          btn.dataset.showPrice === 'true' && detail.price
            ? btn.dataset.label + ' — ' + detail.price
            : btn.dataset.label;
      });
    }

    document.addEventListener('pbs:variant-change', function (event) {
      update(event.detail);
    });

    /* Initial state + Theme Editor re-renders */
    /* Read the selected variant straight from the showcase radios (source of truth) */
    function readChecked() {
      var input = document.querySelector('.pbs__radio-input:checked');
      if (!input) return null;
      return {
        variantId: input.dataset.variantId,
        price: input.dataset.price,
        available: input.dataset.available === 'true'
      };
    }

    /* Initial state + Theme Editor re-renders */
    function applyCurrent() { update(readChecked() || window.pbsState); }
      if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyCurrent);
    } else {
      applyCurrent();
    }
    document.addEventListener('shopify:section:load', applyCurrent);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pbs-showcase')) {
    class PbsShowcase extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.loading = false;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-pbs-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-pbs-thumb]'));
        this.form = this.querySelector('[data-pbs-form]');
        this.submitBtn = this.querySelector('[data-pbs-submit]');
        this.btnText = this.querySelector('[data-pbs-btn-text]');
        this.variantInput = this.querySelector('[data-pbs-variant]');
        this.errorEl = this.querySelector('[data-pbs-error]');
        this.priceEl = this.querySelector('[data-pbs-price]');
        this.compareWrap = this.querySelector('[data-pbs-compare-wrap]');
        this.compareEl = this.querySelector('[data-pbs-compare]');
        this.saveEl = this.querySelector('[data-pbs-save]');
        this.badgeEl = this.querySelector('[data-pbs-badge]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('change', this.onChange);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('change', this.onChange);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      /* ---------- Gallery ---------- */
      showSlide(index) {
        if (index < 0 || index >= this.slides.length) return;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          if (i === index) {
            const img = slide.querySelector('img');
            if (img) img.loading = 'eager';
          }
        });
        this.thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-pressed', String(i === index));
        });
      }

      onClick(event) {
        const thumb = event.target.closest('[data-pbs-thumb]');
        if (!thumb) return;
        this.showSlide(this.thumbs.indexOf(thumb));
      }

      onKeydown(event) {
        const thumb = event.target.closest('[data-pbs-thumb]');
        if (!thumb || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const dir = event.key === 'ArrowRight' ? 1 : -1;
        const next = (this.thumbs.indexOf(thumb) + dir + this.thumbs.length) % this.thumbs.length;
        this.thumbs[next].focus();
        this.showSlide(next);
      }

      /* ---------- Variant selection ---------- */
      onChange(event) {
        const input = event.target;
        if (!input.matches || !input.matches('.pbs__radio-input')) return;
        const d = input.dataset;
        const hasDiscount = Number(d.pct) > 0 && d.compare;

        if (this.priceEl) this.priceEl.textContent = d.price;
        if (this.compareEl) this.compareEl.textContent = hasDiscount ? d.compare : '';
        if (this.compareWrap) this.compareWrap.hidden = !hasDiscount;
        if (this.saveEl) {
          this.saveEl.textContent = hasDiscount ? `${this.dataset.saveLabel} ${d.save}`.trim() : '';
          this.saveEl.hidden = !hasDiscount;
        }
        if (this.variantInput) this.variantInput.value = d.variantId;

        const available = d.available === 'true';
        if (this.submitBtn) {
          this.submitBtn.disabled = !available;
          this.btnText.textContent = available
            ? `${this.submitBtn.dataset.label} — ${d.price}`
            : this.submitBtn.dataset.soldOutLabel;
        }

        if (this.badgeEl) {
          const prefix = this.dataset.badgePrefix || '';
          let text = prefix;
          if (this.dataset.badgeSync === 'true' && Number(d.pct) > 0) {
            text += `${prefix ? ' · ' : ''}${d.pct}% off`;
          }
          this.badgeEl.textContent = text;
          this.badgeEl.hidden = !text;
        }

        if (d.mediaId) {
          const index = this.slides.findIndex((slide) => slide.dataset.mediaId === d.mediaId);
          if (index > -1) this.showSlide(index);
        }

        const detail = { variantId: d.variantId, price: d.price, available };
        window.pbsState = detail;
        document.dispatchEvent(new CustomEvent('pbs:variant-change', { detail }));

        if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', d.variantId);
            window.history.replaceState({}, '', url.toString());
          } catch (error) {
            /* URL update is a nicety, ignore failures */
          }
        }

        this.showError('');
      }

      /* ---------- Add to cart ---------- */
      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }

      setLoading(state) {
        this.loading = state;
        if (!this.submitBtn) return;
        this.submitBtn.classList.toggle('is-loading', state);
        this.submitBtn.setAttribute('aria-busy', String(state));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.loading || !this.submitBtn || this.submitBtn.disabled) return;

        this.setLoading(true);
        this.showError('');

        const mode = this.dataset.afterAdd;
        const cart =
          mode === 'drawer'
            ? document.querySelector('cart-notification') || document.querySelector('cart-drawer')
            : null;

        const body = { id: Number(this.variantInput.value), quantity: 1 };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
        }

        let redirecting = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const json = await response.json();

          if (!response.ok || json.status) {
            this.showError(json.description || json.message || this.dataset.errorMessage);
            return;
          }

          if (cart && typeof cart.renderContents === 'function') {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
            cart.renderContents(json);
          } else {
            redirecting = true;
            window.location.href = mode === 'checkout' ? this.dataset.checkoutUrl : this.dataset.cartUrl;
          }
        } catch (error) {
          this.showError(this.dataset.errorMessage);
        } finally {
          if (!redirecting) this.setLoading(false);
        }
      }
    }

    customElements.define('pbs-showcase', PbsShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
